"use strict";
/*
  MIT LICENSE @liuy97
*/
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var forms_1 = require('@angular/forms');
var AutocompleteComponent = (function () {
    function AutocompleteComponent(elementRef) {
        this.selectEvent = new core_1.EventEmitter();
        this.inputChangedEvent = new core_1.EventEmitter();
        this.thisElement = elementRef.nativeElement;
        this.selectedIndex = 0;
        this.showAutoComplete = false;
        this.value = '';
    }
    AutocompleteComponent.prototype.ngOnInit = function () {
        this.placeholder = 'autocomplete';
        this.inputElement = (this.thisElement.querySelector('input'));
        if (!this.isNull(this.config)) {
            if (!this.isNull(this.config.placeholder)) {
                this.placeholder = this.config.placeholder;
            }
            if (!this.isNull(this.config.sourceField)) {
                this.sourceField = this.config.sourceField;
            }
        }
        this.filterItems(this.value);
        this.inputElement.focus();
    };
    AutocompleteComponent.prototype.ngOnChanges = function () {
        this.filterItems(this.value);
    };
    AutocompleteComponent.prototype.enterText = function (event) {
        var total = this.candidates.length;
        switch (event.keyCode) {
            case 27:
                this.showAutoComplete = false;
                break;
            case 38:
                this.selectedIndex = (total + this.selectedIndex - 1) % total;
                break;
            case 40:
                this.selectedIndex = (total + this.selectedIndex + 1) % total;
                break;
            case 13:
                if (this.candidates.length > 0) {
                    this.onSelect(this.selectedIndex);
                }
                event.preventDefault();
                break;
            default:
                this.value = event.target.value;
                this.inputChangedEvent.emit(this.value);
                break;
        }
    };
    AutocompleteComponent.prototype.onSelect = function (idx) {
        this.showAutoComplete = false;
        this.value = this.candiatesLabels[idx];
        this.selectEvent.emit(this.candidates[idx]);
    };
    AutocompleteComponent.prototype.filterItems = function (search) {
        var field = this.sourceField;
        var filterItem = this.filterItem;
        if (this.items) {
            this.candidates = this.items.filter(function (item) {
                return filterItem(item, field, search);
            });
            this.buildLabels();
        }
    };
    AutocompleteComponent.prototype.getFieldValue = function (object, path) {
        if (typeof object === 'string') {
            return object;
        }
        if (path instanceof Array) {
            var result_1 = object;
            path.forEach(function (element) {
                if (result_1 !== null && result_1 !== undefined
                    && result_1[element] !== null && result_1[element] !== undefined) {
                    result_1 = result_1[element];
                }
                else {
                    result_1 = '';
                }
            });
            return result_1;
        }
        else {
            return object[path] || '';
        }
    };
    AutocompleteComponent.prototype.isNull = function (object) {
        return object === null || object === undefined;
    };
    AutocompleteComponent.prototype.buildLabels = function () {
        var field = this.sourceField;
        var getFieldValue = this.getFieldValue;
        this.candiatesLabels = this.candidates.map(function (e) { return getFieldValue(e, field); });
    };
    AutocompleteComponent.prototype.filterItem = function (item, path, search) {
        if (search === null || search === undefined || search.length === 0) {
            return true;
        }
        var result;
        if (typeof item === 'string') {
            result = item;
        }
        else if (path instanceof Array) {
            result = item;
            path.forEach(function (element) {
                if (result !== null && result !== undefined
                    && result[element] !== null && result[element] !== undefined) {
                    result = result[element];
                }
                else {
                    result = '';
                }
            });
        }
        else {
            result = item[path] || '';
        }
        return result.toLowerCase().indexOf(search.toLowerCase()) >= 0;
    };
    AutocompleteComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'ng2-input-autocomplete',
                    template: "\n  <div class=\"autocomplete\">\n    <input type=\"text\"\n      placeholder=\"{{placeholder}}\"\n      (blur)=\"showAutoComplete = false;\"\n      (focus)=\"showAutoComplete = true;\"\n      [value]=\"value\"\n      (keyup)=\"enterText($event)\">\n    <ul *ngIf=\"showAutoComplete && candidates.length > 0\">\n      <li *ngFor=\"let candidate of candidates; let idx = index\"\n        [ngClass]=\"{ active: (idx === selectedIndex) }\"\n        (mouseover)=\"selectedIndex = idx;\"\n        (mousedown)=\"onSelect(idx)\">\n        {{candiatesLabels[idx]}}\n      </li>\n    </ul>\n  </div>",
                    styles: [
                        ".autocomplete ul {\n       position: absolute;\n       left: 0;\n       width: 100%;\n       border-left: 1px solid #888;\n       border-right: 1px solid #888;\n       border-bottom: 1px solid #888;\n       list-style: none;\n       padding-left: 0px;\n       margin-top: 2px;\n       background-color: #fff;\n       z-index: 100;\n     }\n     .autocomplete li {\n       text-align: left;\n       list-style: none;\n       width: 100%;\n       padding: 0.4em 0 0.4em 0;\n     }\n     .autocomplete li.active {\n       width: 100%;\n       background-color: #4bf;\n     }\n\n     .autocomplete .highlight {\n       background-color: #e2e2e2;\n     }\n     .autocomplete li.active .highlight {\n       background: #666;\n       color: #fff;\n     }"
                    ],
                },] },
    ];
    /** @nocollapse */
    AutocompleteComponent.ctorParameters = function () { return [
        { type: core_1.ElementRef, },
    ]; };
    AutocompleteComponent.propDecorators = {
        'items': [{ type: core_1.Input },],
        'config': [{ type: core_1.Input },],
        'selectEvent': [{ type: core_1.Output },],
        'inputChangedEvent': [{ type: core_1.Output },],
    };
    return AutocompleteComponent;
}());
exports.AutocompleteComponent = AutocompleteComponent;
var AutocompleteDirective = (function () {
    function AutocompleteDirective(resolver, viewContainerRef) {
        var _this = this;
        this.resolver = resolver;
        this.viewContainerRef = viewContainerRef;
        this.ngModelChange = new core_1.EventEmitter();
        this.inputChangedEvent = new core_1.EventEmitter();
        this.selectEvent = new core_1.EventEmitter();
        this.hideAutocomplete = function (event) {
            if (!_this.componentRef) {
                return;
            }
            if (!event || (event.target.querySelector('input') !== _this.thisElement && event.type === 'click')) {
                _this.componentRef.destroy();
                _this.componentRef = undefined;
            }
            if (_this.inputElement['tabIndex'] < 0) {
                _this.inputElement['tabIndex'] = _this.tabIndex;
            }
        };
        this.onInputChanged = function (val) {
            _this.inputElement.value = val;
            if (val !== _this.ngModel) {
                _this.ngModelChange.emit(val);
            }
            var component = _this.componentRef.instance;
            component.filterItems(val);
            _this.inputChangedEvent.emit(val);
        };
        this.onSelect = function (item) {
            var component = _this.componentRef.instance;
            var val = component.value;
            if (val !== _this.ngModel) {
                _this.ngModelChange.emit(val);
            }
            _this.selectEvent.emit(item);
            if (_this.inputElement) {
                _this.inputElement.value = '' + val;
            }
            _this.hideAutocomplete();
        };
        this.thisElement = this.viewContainerRef.element.nativeElement;
    }
    AutocompleteDirective.prototype.ngOnInit = function () {
        this.createDiv();
    };
    AutocompleteDirective.prototype.ngOnDestroy = function () {
        if (this.componentRef) {
            this.componentRef.instance.selectEvent.unsubscribe();
            this.componentRef.instance.inputChangedEvent.unsubscribe();
        }
        document.removeEventListener('click', this.hideAutocomplete);
    };
    AutocompleteDirective.prototype.ngOnChanges = function (changes) {
        if (changes['items'] && this.componentRef) {
            var component = this.componentRef.instance;
            component.items = changes['items'].currentValue;
            component.filterItems(component.value);
        }
    };
    AutocompleteDirective.prototype.showAutocomplete = function () {
        this.hideAutocomplete();
        this.createAutocomplete();
    };
    AutocompleteDirective.prototype.createDiv = function () {
        var element = document.createElement('div');
        element.style.display = 'inline-block';
        element.style.position = 'relative';
        this.thisElement.parentElement.insertBefore(element, this.thisElement.nextSibling);
        element.appendChild(this.thisElement);
        document.addEventListener('click', this.hideAutocomplete);
    };
    AutocompleteDirective.prototype.createAutocomplete = function () {
        var factory = this.resolver.resolveComponentFactory(AutocompleteComponent);
        this.componentRef = this.viewContainerRef.createComponent(factory);
        var component = this.componentRef.instance;
        component.config = this.config;
        component.items = this.items;
        component.selectEvent.subscribe(this.onSelect);
        component.inputChangedEvent.subscribe(this.onInputChanged);
        this.autocompleteElement = this.componentRef.location.nativeElement;
        this.autocompleteElement.style.display = 'none';
        this.inputElement = this.thisElement;
        if (this.thisElement.tagName !== 'INPUT' && this.autocompleteElement) {
            this.inputElement = this.thisElement.querySelector('input');
            this.inputElement.parentElement.insertBefore(this.autocompleteElement, this.inputElement.nextSibling);
        }
        component.value = this.inputElement.value;
        this.tabIndex = this.inputElement['tabIndex'];
        this.inputElement['tabIndex'] = -100;
        if (this.componentRef) {
            var rect = this.thisElement.getBoundingClientRect();
            var style = this.autocompleteElement.style;
            style.width = rect.width + 'px';
            style.position = 'absolute';
            style.zIndex = '1';
            style.top = '0';
            style.left = '0';
            style.display = 'inline-block';
        }
    };
    AutocompleteDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[autocomplete]',
                },] },
    ];
    /** @nocollapse */
    AutocompleteDirective.ctorParameters = function () { return [
        { type: core_1.ComponentFactoryResolver, },
        { type: core_1.ViewContainerRef, },
    ]; };
    AutocompleteDirective.propDecorators = {
        'config': [{ type: core_1.Input },],
        'items': [{ type: core_1.Input },],
        'ngModel': [{ type: core_1.Input },],
        'ngModelChange': [{ type: core_1.Output },],
        'inputChangedEvent': [{ type: core_1.Output },],
        'selectEvent': [{ type: core_1.Output },],
        'showAutocomplete': [{ type: core_1.HostListener, args: ['click',] }, { type: core_1.HostListener, args: ['focus',] },],
    };
    return AutocompleteDirective;
}());
exports.AutocompleteDirective = AutocompleteDirective;
var AutocompleteModule = (function () {
    function AutocompleteModule() {
    }
    AutocompleteModule.forRoot = function () {
        return {
            ngModule: AutocompleteModule
        };
    };
    AutocompleteModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, forms_1.FormsModule],
                    declarations: [AutocompleteComponent, AutocompleteDirective],
                    exports: [AutocompleteComponent, AutocompleteDirective],
                    entryComponents: [AutocompleteComponent]
                },] },
    ];
    /** @nocollapse */
    AutocompleteModule.ctorParameters = function () { return []; };
    return AutocompleteModule;
}());
exports.AutocompleteModule = AutocompleteModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-input-autocomplete/bundles/ng2-input-autocomplete.js
// module id = 1138
// module chunks = 4